export class QualityLevel {
  id: string;
  width: number;
  height: number;
  bandwidth: number;
  isCurrent: boolean;
  dimension: string;

  constructor(id: string, width: number, height: number, bandwidth: number, isCurrent: boolean) {
    this.id = id;
    this.width = width;
    this.height = height;
    this.bandwidth = bandwidth;
    this.isCurrent = isCurrent;
    this.dimension = width + "x" + height;
  }
}
